<template>
    <div class="detail-layout" :style="detailLayoutStyle">
        <CampaignPicture class="detail-layout__picture"
            :imgClass="'default'"
            :campaignImage="detailController.campaign.pictures" />

        <div class="detail-layout__info-wrapper">
            <DetailInfo class="detail-layout__info"
                :lbl="lbl"
                :locale="locale"
                :campaign="detailController.campaign" />
            <DetailAndCondition
                :lbl="lbl"
                :locale="locale"
                :campaign="detailController.campaign" />
        </div>

        <div class="detail-layout__redeem-wrapper">
            <div class="detail-layout__balance" v-if="shouldShowBalance && !showExplorePrestigeCase">
                <div class="detail-layout__balance-label">{{ lbl.redeem_button.remaining }}</div>
                <div class="detail-layout__balance-label">{{ lbl.redeem_button.use }}</div>
            </div>

           <!-- case credit -->
           <div class="detail-layout__balance-value" v-if="isCredit && !showExplorePrestigeCase">
                <div class="detail-layout__balance-credit" v-if="userPoint !== null && userPoint !== 0" >
                    <img src="@/assets/icon/ic-credit.png" alt="icon-credit" class="icon-credit">
                    <span class="balance-value" :key="userPoint">
                        {{ userPoint | number_format }} {{ getUnitLabel(userPoint) }}
                    </span>
                    <!-- <span>
                        {{ userPoint | number_format }} {{ getUnitLabel(userPoint) }}
                    </span> -->
                </div>
                <div class="detail-layout__balance-credit no-points" v-else>
                    <img src="@/assets/icon/ic-warning-red.svg" alt="ic-warning-point" class="icon-warning">
                    <span class="no-points-text">
                        {{ 0 | number_format }} {{ getUnitLabel(0) }}
                    </span>
                </div>
                <div class="detail-layout__balance-point">
                    <span v-if="amountPerUnit !== null">
                        {{ amountPerUnit | number_format }} {{ getUnitLabel(amountPerUnit) }}
                    </span>
                </div>
            </div>

            <!-- case point (non-credit) -->
            <div class="detail-layout__balance-value" v-else-if="isNonCredit && pointPerUnit !== 0 && pointPerUnit !== null">
                <div class="detail-layout__balance-credit" v-if="pointBalance !== null">
                    <img src="@/assets/icon/ic-aia-point.png" alt="ic-aia-point" class="icon-aia-point">
                    <span class="balance-value" :key="pointBalance">
                        {{ pointBalance | number_format }} {{ getUnitLabel(pointBalance) }}
                    </span>
                    <!-- <span>
                        {{ pointBalance | number_format }} {{ getUnitLabel(pointBalance) }}
                    </span> -->
                </div>
                <div class="detail-layout__balance-credit no-points" v-else>
                    <img src="@/assets/icon/ic-warning-red.svg" alt="ic-warning-point" class="icon-warning">
                    <span class="no-points-text">
                        {{ 0 | number_format }} {{ getUnitLabel(0) }}
                    </span>
                </div>
                <div class="detail-layout__balance-point">
                    <span v-if="pointPerUnit !== null">
                        {{ pointPerUnit | number_format }} {{ getUnitLabel(pointPerUnit) }}
                    </span>
                </div>
            </div>
            
            <RedeemButton
                class="detail-layout__redeem"
                :isLogin="isLogin"
                :key="currentUserPoint"
                :userPoint="currentUserPoint"
                :isCheckQuotaAvailable="isCheckQuotaAvailable"
                :isQuotaAvailable="isQuotaAvailable"
                :detailController="detailController"
                :lblRedeemBTN="lbl.redeem_button"
                :modalController="modalController"
                v-if="isQuotaLoaded" />
        </div>
      

        <!-- <RedeemButton
            class="layout-redeem"
            :class="[{'redeem-mass': theme == 'mass'}, {'redeem-prestige': theme == 'prestige'}]"
            :isLogin="isLogin"
            :userPoint="userPoint"
            :isCheckQuotaAvailable="isCheckQuotaAvailable"
            :isQuotaAvailable="isQuotaAvailable"
            :detailController="detailController"
            :lblRedeemBTN="lbl.redeem_button"
            v-if="isQuotaLoaded" /> -->
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import CampaignPicture from "../detail/Picture.vue";
import DetailInfo from '../detail/DetailInfo.vue';
import DetailAndCondition from "../detail/DetailAndCondition.vue";
import RedeemButton from "../detail/RedeemButton.vue";
import AIACampaignService from '@/module/Detail/service/AIACampaignService.js';
/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "DefaultLayout",
    mixins: [ErrorApiMixin],
    components: {
        CampaignPicture,
        DetailInfo,
        DetailAndCondition,
        RedeemButton
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isCredit: function () {
            var campaign = this.detailController.campaign;
            // case credit
            return campaign && 
                   campaign.pointServices &&
                   campaign.pointServices.credit !== null &&
                   campaign.pointServices.credit !== undefined &&
                   campaign.pointServices.credit.amountPerUnit !== undefined;
        },
        isNonCredit: function () {
            var campaign = this.detailController.campaign;
            // case non-credit
            return campaign && 
                   campaign.pointServices &&
                   campaign.pointServices.credit === null &&
                   campaign.pointPerUnit >= 0;

        },
        shouldShowBalance: function () {
            // case credit or non-credit
            if (this.isCredit) {
                return true;
            }
            if (this.isNonCredit) {
                return this.pointPerUnit !== 0 && this.pointPerUnit !== null;
            }
            return false;
        },
        pointBalance: function () {
            if (this.isLogin) {
                if (this.isCredit) {
                    // case credit
                    var profile = Account.getCacheProfile();
                    if (profile && profile.points && profile.points.length > 0) {
                        return profile.points[0].Balance || null;
                    }
                } else if (this.isNonCredit) {
                    if (this.pointsBalanceFromApi !== null && this.pointsBalanceFromApi !== undefined) {
                        return this.pointsBalanceFromApi;
                    }
                    // Don't return null to prevent showing "no-points" while loading
                    return undefined;
                }
            }
            return null;
        },
        pointUnit: function () {
            if (this.isLogin && this.isCredit) {
                var profile = Account.getCacheProfile();
                if (profile && profile.points && profile.points.length > 0) {
                    return profile.points[0].Unit || null;
                }
            }
            return null;
        },
        amountPerUnit: function () {
            if (this.isCredit) {
                var campaign = this.detailController.campaign;
                // ใช้ pointServices.credit.Amount
                if (campaign && 
                    campaign.pointServices && 
                    campaign.pointServices.credit && 
                    campaign.pointServices.credit.amountPerUnit !== null &&
                    campaign.pointServices.credit.amountPerUnit !== undefined) {
                    return campaign.pointServices.credit.amountPerUnit;
                }
            }
            return null;
        },
        pointPerUnit: function () {
            if (this.isNonCredit) {
                // กรณี non-credit: แสดง pointPerUnit
                var campaign = this.detailController.campaign;
                if (campaign && campaign.pointPerUnit !== null && 
                    campaign.pointPerUnit !== undefined) {
                    return campaign.pointPerUnit;
                }
            }
            return null;
        },
        currentUserPoint: function() {
            // send userPoint if isCredit
            if (this.isCredit) {
                return this.userPoint || 0;
            }
            // send pointBalance if isNonCredit
            else if (this.isNonCredit) {
                return this.pointBalance != null ? this.pointBalance : 0;
            }
            return 0;
        },
        showExplorePrestigeCase: function () {
            return this.theme === 'mass' &&
                this.isCredit &&
                this.amountPerUnit != null &&
                this.amountPerUnit > 0;
        },
        detailLayoutStyle: function () {
            return {
                paddingTop: this.headerOffsetTop + 'px'
            };
        },
    },
    props: {
        lbl: Object,
        locale: Number,
        detailController: Object,
        modalController: Object
    },
    data: function() {
        return {
            isCheckQuotaAvailable: false,
            isQuotaAvailable: false,
            isQuotaLoaded: false,

            isLogin: Account.isLogin(),
            userPoint: Account.getCachePointFromProfile(),
            pointsBalanceFromApi: null,
            headerOffsetTop: 48
        };
    },
    created: function () {
        this.initialQuota();
        this.initialDetailControllerEvent();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);

        this.detailController.cbUpdatePoint.onCallback((data) => {
            this.$nextTick(() => {
                if (this.isCredit && this.isLogin && data) {
                    var balance = data.PointServiceBalance || data.pointServiceBalance;
                    if (balance != null) {
                        var profile = Account.getCacheProfile();
                        if (profile && profile.points && profile.points[0]) {
                            profile.points[0].Balance = balance;
                            Account.setCacheProfile(profile);
                            this.userPoint = balance;
                        }
                    }
                }
                if (this.isNonCredit && this.isLogin) this.fetchPointsBalance();
            });
        });
    },
    mounted: function () {
        this.updateHeaderOffset();
        window.addEventListener('resize', this.updateHeaderOffset);
    },
    beforeDestroy: function () {
        window.removeEventListener('resize', this.updateHeaderOffset);
    },
    methods: {
        updateHeaderOffset: function () {
            this.$nextTick(() => {
                var headerEl = document.getElementById('aia_header');
                this.headerOffsetTop = headerEl && headerEl.offsetHeight ? headerEl.offsetHeight : 48;
            });
        },
        fetchPointsBalance: function () {
            if (!this.isNonCredit || !this.isLogin) {
                return;
            }
            
            var token = Account.getToken();
            if (!token) {
                return;
            }
            
            var campaign = this.detailController.campaign;
            if (!campaign) {
                return;
            }
            
            var profile = Account.getCacheUserDetail();
            var transactionId = profile && profile.UserId ? profile.UserId : null;
            if (!transactionId) {
                return;
            }

            AIACampaignService.apiGetPointsBalance(token, transactionId)
                .then(res => {
                   this.pointsBalanceFromApi = res.Balance != null ? res.Balance : res.balance;
                })
                .catch(error => {
                    console.log('pointsBalanceFromApi error', error);
                    this.pointsBalanceFromApi = null;
                });
        },
        getUnitLabel: function (amount) {
            var label;
            if (this.isNonCredit) {
                label = this.lbl.detail.point;
            } else {
                var unit = this.pointUnit || 'credit';
                label = unit.toLowerCase() === 'credit' 
                    ? this.lbl.redeem_button.credits 
                    : this.lbl.detail.point;
            }
            return (amount > 1 && this.locale === 1033) ? label + 's' : label;
        },
        initialDetailControllerEvent: function () {
            this.detailController.cbOpenWeb
                .onCallback(this.openWebsite);

            this.detailController.cbOpenSurvey
                .onCallback(() => {

                });

            this.detailController.cbCallApi
                .onCallback(() => {

                });

            this.detailController.cbShoppingCart
                .onCallback(this.openShoppingCart);

            this.detailController.cbRedeemSuccess
                .onCallback(data => {
                    switch(data.type) {
                        case 'route':
                            this.$router.push(data.link);
                            break;
                        case 'relocation':
                            window.location.replace(data.link);
                            break;
                    }
                });
        },
        //#region quota
        initialQuota: function () {
            if (this.detailController.quota) {
                this.isCheckQuotaAvailable = true;
                this.isQuotaAvailable = (this.detailController.quota.Available > 0)
            } else {
                this.isCheckQuotaAvailable = false;
                this.isQuotaAvailable = false;
            }

            this.isQuotaLoaded = true;
        },
        //#endregionquota
        //callback event
        openWebsite: function (website) {
            if (!website) return;

            var webUrl = website;
            var isShowHeader = 'false';
            var theme = Vue.bzbsConfig.appname;
            var appName = Vue.bzbsConfig.appname;
            var suffledToken = Account.getTokenShuffle();

            if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0) {
                Account.setCacheCustom('isfromlanding', { page: 'interface' });
            } else if (webUrl.indexOf('wondd') >= 0) {
                Account.setCacheCustom('isfromlanding', { page: 'wodd' });
            } else {
                Account.setCacheCustom('isfromlanding', { page: 'other' });
            }

            webUrl += '&token=' + suffledToken
                    + '&appName=' + appName
                    + '&locale=' + this.localeCode
                    + '&header=' + isShowHeader
                    + '&theme=' + theme
                    + '&return_url=' + encodeURIComponent(window.location.href);

            window.location.href = webUrl;
        },
        openShoppingCart: function (website) {
            if(!website) return;

            var bzbsToken = Account.getToken();
            var localeCode = this.locale;
            var returnUrl = encodeURIComponent(window.location.href);
            var strUrl = '';
            var strLocale = '';
            var strEncryptToken = Util.shuffleToken(bzbsToken);
            switch(localeCode) {
                case 1033:
                    strLocale = 'E';
                    break;
                case 1054:
                    strLocale = 'T';
                    break;
            }

            if (this.campaign.website.indexOf('.buzzebees.com/payment/')) {
                var arrSplittedUrl = this.campaign.website.split('/payment');
                strUrl = `${Vue.bzbsConfig.bzbShoppingCartUrl}/payment${arrSplittedUrl[1]}&token=${strEncryptToken}&return_url=${returnUrl}&locale=${strLocale}`;
            } else {
                strUrl = `${website}&token=${strEncryptToken}&return_url=${returnUrl}&locale=${strLocale}`;
            }

            window.location = strUrl;
        }
    },
    watch: {
        'detailController.campaign': {
            handler: function (newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        this.fetchPointsBalance();
                        this.updateHeaderOffset();
                    });
                }
            },
            immediate: true,
            deep: false 
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/Detail/component/layout/Layout.scss";
    
    .balance-value {
        transition: opacity 0.3s ease, transform 0.3s ease;
        display: inline-block;
    }
    
    .detail-layout__balance-credit {
        .balance-value {
            opacity: 1;
        }
    }
</style>
